import { render, staticRenderFns } from "./datasubject-legal-form.vue?vue&type=template&id=45ea28e4&scoped=true"
import script from "./datasubject-legal-form.vue?vue&type=script&lang=js"
export * from "./datasubject-legal-form.vue?vue&type=script&lang=js"
import style0 from "./datasubject-legal-form.vue?vue&type=style&index=0&id=45ea28e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea28e4",
  null
  
)

export default component.exports